// eslint-disable-next-line no-unused-vars
import { AllowedSubscriptionFeaturesMessage } from "../http/core/models/AllowedSubscriptionFeaturesMessage";
// eslint-disable-next-line no-unused-vars
import { UserBasicDetailsMessage } from "../http/core/models/UserBasicDetailsMessage";

export type Actions =
  "SET_NOT_AUTHENTICATED"
  | "SET_AUTH_TOKEN"
  | "SET_USER_BASIC_DETAILS"
  | "SET_SUBSCRIPTION_ALLOWED_FEATURES"
  | "SET_SHOW_ERROR"
  | "ADD_API_ERROR"
  | "CLEAR_API_ERRORS"

export interface StoreAction {
  type: Actions,
  payload: any,
}
export function clearNotAuthenticated() {
  return {
    type: "SET_NOT_AUTHENTICATED",
    payload: {
      isAuthenticated: true,
    },
  };
}

export const setNotAuthenticated = (retryHandler: () => Promise<any>): StoreAction => ({
  type: "SET_NOT_AUTHENTICATED",
  payload: {
    isAuthenticated: false,
    retryHandler,
  },
});

export const setAccessToken = (
  accessToken: string,
  tokenExpirationDate: Date,
  tokenCreationDate: Date
): StoreAction => ({
  type: "SET_AUTH_TOKEN",
  payload: {
    accessToken,
    tokenExpirationDate,
    tokenCreationDate,
  },
});

export const setUserBasicDetails = (
  details: UserBasicDetailsMessage
): StoreAction => ({
  type: "SET_USER_BASIC_DETAILS",
  payload: details,
});

export const setSubscriptionAllowedFeatures = (
  details: Array<AllowedSubscriptionFeaturesMessage>
): StoreAction => ({
  type: "SET_SUBSCRIPTION_ALLOWED_FEATURES",
  payload: details,
});

export const showError = (): StoreAction => ({
  type: "SET_SHOW_ERROR",
  payload: true,
});

export const hideError = (): StoreAction => ({
  type: "SET_SHOW_ERROR",
  payload: false,
});

export const addApiError = (error: any)
  : StoreAction => ({
  type: "ADD_API_ERROR",
  payload: {
    apiError: error,
  },
});

export const clearApiErrors = ()
  : StoreAction => ({
  type: "CLEAR_API_ERRORS",
  payload: null,
});
